import React from 'react'

const Entrega=()=>{
  return(
    <div className="entrega">
      <div className="entrega-container">
        <div className="entrega-container-image">
          <img src="/icons/entrega.svg" alt="entrega"/>
        </div>
        <p>Entrega por Olva Courier o agencias de su preferencia</p>
      </div>
      <div className="entrega-container">
        <div className="entrega-container-image">
          <img src="/icons/amor.svg" alt="amor"/>
        </div>
        <p>Productos de alta calidad y hechos a mano con mucho amor</p>
      </div>
    </div>
  )
}

export default Entrega
